import clubRequest from "../axios";
import { CreateAppInfoPayload } from "./type";

const updateAppInfo = async (command: CreateAppInfoPayload) =>
  (await clubRequest.appInfoCreate(command)).data;

const updateAppInfoUpdate = async (imei: string) =>
  (
    await clubRequest.appInfoChangeUpdate({
      imei: imei,
    })
  ).data;

export const appInfo = {
  updateAppInfo,
  updateAppInfoUpdate,
};
